<div class="infos-panel">

  <!-- Banner: citizen-facing indicator + status value -->
  <div class="panel-banner">
    <div class="banner-left">
      <mat-icon class="banner-icon">visibility</mat-icon>
      <span>{{ 'permit.manage.detail.visible_citizen' | translate }}</span>
    </div>
    <div
      class="status-badge"
      *ngIf="permit?.state"
      [ngStyle]="{ 'background-color': getChipBackgroundColor(permit.state.color) }">
      <span class="status-indicator" [ngStyle]="{ 'background-color': permit.state.color }"></span>
      <span class="status-text">{{ statusName(permit.state.name) }}</span>
    </div>
  </div>

  <app-bciti-tabs [badges]="[false, unreadCitizenCount > 0]" (click)="detectActiveTab()">

    <app-bciti-tab [title]="'permit.manage.detail.tab_infos' | translate">
      <app-permit-info [permit]="permit" (permitUpdated)="permitUpdated.emit()"></app-permit-info>
    </app-bciti-tab>

    <app-bciti-tab [title]="'permit.manage.detail.tab_messages' | translate">
      <app-permit-messages
        [permit]="permit"
        [active]="messagesActive"
        (messagesRead)="onMessagesRead()"
        (permitUpdated)="permitUpdated.emit()">
      </app-permit-messages>
    </app-bciti-tab>

  </app-bciti-tabs>

</div>
